import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { AddReactionRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { AddReactionResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const addReaction = (request: AddReactionRequest, options?: CashRequestOptions) =>
  post<AddReactionRequest, AddReactionResponse>('/2.0/cash/add-reaction', request, { ...options, rejectOnError: true })
